import Head from 'next/head';
import React from 'react';
var Preconnect = function (props) {
    var _a = props.list, list = _a === void 0 ? [] : _a;
    return (
    /**
     * We cannot just put this on "head" page/layout config because
     * Head Next component cannot render a component, just directly
     * link, script, title and others tags.
     * related issue: https://github.com/vercel/next.js/issues/8384
     */
    React.createElement(Head, null, list.length
        ? list.map(function (item) { return (
        // eslint-disable-next-line react/jsx-indent
        React.createElement("link", { crossOrigin: "anonymous", "data-testid": "preconnect-item", href: item, key: "preconnect-".concat(item), rel: "preconnect" })); })
        : null));
};
export default Preconnect;
//# sourceMappingURL=Preconnect.js.map